export { default } from './toLowerCaseFirst'
export * from './toLowerCaseFirst'
